import React, { useCallback, useState } from 'react';
import { Button, Notifications } from '@beef/ui-kit';
import PropTypes from 'prop-types';

const getNow = () => +(new Date());
export const NotificationComponent = ({ children, duration, message, onClick }) => {
  const [notifications, setNotifications] = useState([]);
  const handleCreateNotify = useCallback(() => {
    onClick();
    setNotifications([
      ...notifications,
      {
        id: getNow(),
        text: message,
      },
    ]);
  }, [notifications]);

  const handleRemoveNotify = useCallback((id) => {
    setNotifications((prevState) => (
      prevState.filter(
        (notification) => notification.id !== id,
      )));
  }, []);
  return (
    <div>
      <Button variant="plain" onClick={handleCreateNotify}>
        {children}
      </Button>
      {notifications && (
        <Notifications
          duration={duration}
          notifications={notifications}
          onClick={handleRemoveNotify}
        />
      )}
    </div>
  );
};

NotificationComponent.propTypes = {
  duration: PropTypes.number,
  message: PropTypes.string,
  onClick: PropTypes.func,
};
